module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vback12-e9927c4e924d85a2464d82d9053690f6.jpg";